import { combineReducers } from 'redux';

// reducer import
import authReducer from './authReducer';
import customizationReducer from './customizationReducer';
import menuReducer from './menuReducer';
import breadcrumbReducer from './breadcrumbReducer';
import signalrReducer from './signalrReducer';
import roleReducer from './roleReducer';
// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    customization: customizationReducer,
    auth: authReducer,
    menu: menuReducer,
    breadcrumbs: breadcrumbReducer,
    signalr: signalrReducer,
    role: roleReducer
});

export default reducer;
